module.exports = {
	status: "prod",
	googleFontKey: 'AIzaSyA_surnT74A_ghn2FbwxRiuAKgioUVfJEM',
	// local: {
	// 	apiUrl: "https://test-platform.adcropper.com/api",
	// 	platformUrl: "http://localhost:3001",s
	// 	fontUrl: 'https://test-platform.adcropper.com/fonts',
	// 	previewUrl: "http://127.0.0.1:5000/preview.html",
	// 	pluginUrl: "http://localhost:5001/timelineFunction.html",
	// 	showcaseUrl: "http://localhost:3002",
	// 	feedUrl: 'https://test-platform.adcropper.com/feed/',
	// 	analyticsUrl: 'https://analytics.adcropper.com'
	// },
	local: {
		apiUrl: 'http://localhost:3000',
		platformUrl: 'https://localhost:80',
		fontUrl: 'http://localhost:3002',
		previewUrl: 'http://localhost:81',
		pluginUrl: 'http://localhost:82',
		showcaseUrl: 'http://localhost:83',
		feedUrl: 'http://localhost:3001'
	},
	test: {
		apiUrl: "https://test-platform.adcropper.com/api",
		platformUrl: "https://test-platform.adcropper.com",
		fontUrl: "https://test-platform.adcropper.com/fonts",
		previewUrl: "https://test-plugin.adcropper.com/preview/preview.html",
		// previewUrl: "http://localhost:5000/preview.html",
		pluginUrl: "https://test-plugin.adcropper.com/index.html",
		// pluginUrl: "http://localhost:5502/index.html",
		showcaseUrl: "https://test-plugin.adcropper.com/showcase/index.html",
		// showcaseUrl: "http://localhost:3001",
		feedUrl: 'https://test-platform.adcropper.com/feed/',
		analyticsUrl: 'https://analytics.adcropper.com'
	},
	prod: {
		apiUrl: "https://app.adcropper.com",
		platformUrl: "https://platform.adcropper.com",
		fontUrl: 'https://fonts.adcropper.com/fonts',
		previewUrl: "https://preview.adcropper.com",
		// previewUrl: "http://localhost:5000/preview.html",
		pluginUrl: "https://plugin.adcropper.com/figma/index.html",
		// pluginUrl: 'http://127.0.0.1:5502/index.html',
		showcaseUrl: "https://showcase.adcropper.com",
		feedUrl: 'https://feed.adcropper.com/',
		analyticsUrl: 'https://analytics.adcropper.com'
	},
};


